import { Controller } from 'stimulus';
import cookie from '../helpers/cookie';

class ColorSwitchController extends Controller {
  // eslint-disable-next-line class-methods-use-this
  onToggle() {
    document.body.classList.toggle('is-dark-mode');

    const isDarkMode = document.body.classList.contains('is-dark-mode');

    cookie.set('dark_mode', isDarkMode ? 1 : 0);
  }
}

ColorSwitchController.targets = [
  //
];

export default ColorSwitchController;
